import { render, staticRenderFns } from "./debounce-select.vue?vue&type=template&id=20fce40c"
import script from "./debounce-select.vue?vue&type=script&lang=js"
export * from "./debounce-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports